import { render } from "./PaymentOutcome.vue?vue&type=template&id=630587ba&scoped=true"
import script from "./PaymentOutcome.vue?vue&type=script&lang=js"
export * from "./PaymentOutcome.vue?vue&type=script&lang=js"

import "./PaymentOutcome.vue?vue&type=style&index=0&id=630587ba&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630587ba"]])

export default __exports__